<!--
 * @Author: zxf
 * @Date: 2022-08-05 19:05:06
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 16:33:05
 * @Description: 建筑物信息查看
-->

<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-80 o-dialog--lg-60 o-dialog--xl-50"
    title="建筑信息查看"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <el-form
      ref="fd"
      class="c-form"
      :model="fd"
      :inline="true"
      label-position="right"
      label-width="150px"
      label-suffix="："
    >
      <el-row
        class="c-form__row"
      >
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="建筑名称（栋）"
            prop="jzwmc"
          >
            <span class="c-form__read">{{ fd.jzwmc }}</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="面积（m²）"
            prop="mj"
          >
            <span class="c-form__read">{{ fd.mj }}</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="高度（m）"
            prop="gd"
          >
            <span class="c-form__read">{{ fd.gd }}</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="地上层层数"
            prop="dscs"
          >
            <span class="c-form__read">{{ fd.dscs }}</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="地下层层数"
            prop="dxcs"
          >
            <span class="c-form__read">{{ fd.dxcs }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>

import { jzwService } from './jzw.service';
export default {
  name: 'JcjzwViewDialog',
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false, // 页面loading计划年份
      dialogShow: true, // 模态框dialog显示

      /* 表单参数 Start */
      fd: {
        jzwmc: null, // 建筑名称（栋）
        mj: null, // 面积（m²）
        gd: null, // 高度（m）
        dxcs: null, // 地下层数
        dscs: null // 地上层数
      }
      /* 表单参数 End */

    };
  },
  computed: {
    /* 根据模态框类型动态展示标题 */
    dlTitle () {
      return `${this.dlType === 'edit' ? '建筑信息编辑' : '建筑信息新增'}`;
    }
  },
  methods: {

    /**
     * @description: 初始化建筑物信息
     * @return {*}
     */
    async init () {
      this.loading = true;
      await jzwService.getJzwInfo(this.dlParams.id)
        .then(rsp => {
          this.fd = Object.assign({}, this.fd, rsp.data);
        })
        .catch(err => {
          console.error('获取建筑物信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  created () {
    this.init();
  }
};
</script>
